module.exports = __webpack_public_path__ + "img/trending-down.d6e5c601.svg";